import { DialogActions } from "@mui/material";
import * as React from "react";

export default ({ children, style }: { children: React.ReactNode; style?: React.CSSProperties }) => (
    <DialogActions style={{ padding: "5px 8px", ...style }}>{children}</DialogActions>
);
